import React from "react";
import { useTranslation } from "react-i18next";

export default function CovidPolicy() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-1 bg-white max-md:min-h-[calc(100vh-100px)] max-md:pt-10 max-md:px-6">
      <p className="text-black font-bold text-lg">{t("settings.covid")}</p>
      <p className="text-black">
        {"Through partnership with public health agencies, Docket® offers consumer " +
          "access to COVID-19 immunization records. As such, Docket® only accesses personal and sensitive data " +
          "required directly to support COVID-19-related efforts. Specifically, Docket® uses this data to " +
          "facilitate consumer access to personal and family immunization records."}
      </p>
    </div>
  );
}
